import Header from 'components/Header'
import { Column } from 'components/Flex'
import { SkeletonImageBuy } from 'utils'

import { Skeleton } from '@interco/inter-ui/components/Skeleton'

import * as S from '../styles'

export const LoadingView = () => (
  <S.Wrapper>
    <Header title="Detalhes da compra" />
    <S.Sections data-testid="skeleton-section">
      <S.Section>
        <Skeleton width="30%" height="30px" animation="pulse" />
        <div />
        <div />
        <Column $gap="12px" style={{ overflowX: 'hidden', margin: '0 auto' }}>
          <SkeletonImageBuy />
          <Skeleton width="30%" height="30px" animation="pulse" />
          <Skeleton width="50%" height="15px" animation="pulse" />
          <Skeleton width="50%" height="15px" animation="pulse" />
        </Column>
        <br />
        <br />
        <br />
        <Skeleton width="50%" height="13px" animation="pulse" />
        <Skeleton width="80%" height="13px" animation="pulse" />
      </S.Section>
      <S.Section>
        <Skeleton width="100%" height="20rem" animation="pulse" style={{ margin: '0 auto' }} />
      </S.Section>
      <Skeleton width="100%" height="30px" animation="pulse" />
    </S.Sections>
  </S.Wrapper>
)

export default LoadingView
